module.exports = "/_next/static/images/truck8-ba5b163a502acb3348bc3360eab41ac1.png.webp";